import * as React from "react";
import {VisuallyHidden} from "@unibuddy/patron";
import {SVGProps, memo} from "react";

const GoodEmoji = (props: SVGProps<SVGSVGElement>) => (
    <>
        <VisuallyHidden>😀</VisuallyHidden>
        <svg
            aria-hidden
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 72 72"
            width="1em"
            height="1em"
            {...props}
        >
            <circle
                cx={36}
                cy={36}
                r={23}
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
            <path
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M45.815 44.93c-2.9 1.635-6.248 2.57-9.815 2.57s-6.915-.934-9.815-2.57"
            />
            <path d="M30 31a3.001 3.001 0 0 1-6 0c0-1.655 1.345-3 3-3s3 1.345 3 3M48 31a3.001 3.001 0 0 1-6 0c0-1.655 1.345-3 3-3s3 1.345 3 3" />
        </svg>
    </>
);

const Memo = memo(GoodEmoji);
export default Memo;
